import React from 'react';

import { CheckboxSIcon } from 'assets/icons';
import { Icon } from 'components/uikit/Icon/Icon';

import * as S from './Step.styles';

export const Step = ({ active, children, first, fulfilled, last }) => {
  return (
    <S.Container first={first} last={last}>
      <S.Indicator active={active} fulfilled={fulfilled}>
        {Boolean(fulfilled) && <Icon size="xs" Icon={CheckboxSIcon} />}
      </S.Indicator>
      <S.Title active={active} fulfilled={fulfilled}>
        {children}
      </S.Title>
    </S.Container>
  );
};
